import { CancelToken } from "axios";

/**
 * Mixin that generate an Axios CancelToken,
 * that can cancel requests based on vue lifecycle and events
 */

export const SourceToken = {
    data: () => ({
        sourceToken: undefined
    }),
    created() {
        this.setSourceToken();
    },
    methods: {
        setSourceToken() {
            this.sourceToken = CancelToken.source();
        }
    },
    beforeDestroy() {
        if (this.sourceToken) this.sourceToken.cancel("Component Destroyed");
    }
};